/**
 * Test IDs for QA automation.
 */
export const testIds = {
  goodProfileEquivalenceConditionFormTarget: "good-profile-equivalence-condition-form-target",
  goodProfileEquivalenceConditionFormTargetOption: "good-profile-equivalence-condition-form-target-option",
  goodProfileEquivalenceConditionFormOperator: "good-profile-equivalence-condition-form-operator",
  goodProfileEquivalenceConditionFormOperatorOption: "good-profile-equivalence-condition-form-operator-option",
} as const;
